import { render, staticRenderFns } from "./keywordReplyModal.vue?vue&type=template&id=6872ee64&scoped=true"
import script from "./keywordReplyModal.vue?vue&type=script&lang=js"
export * from "./keywordReplyModal.vue?vue&type=script&lang=js"
import style0 from "./keywordReplyModal.vue?vue&type=style&index=0&id=6872ee64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872ee64",
  null
  
)

export default component.exports